<!-- PAGE HEADER-->
<hw-page-header class="page-header">
  <h1>{{ 'mdm.snomed-01.header' | translate }}</h1>
</hw-page-header>
<!-- //PAGE HEADER-->

<nz-content class="main">
  <!-- CONTAINER -->
  <div class="container">
    <div style="display: flex">
      <hw-snomed-input-search
        #snomedSearch
        [conceptParams]="conceptParams"
        [descriptionParams]="descriptionParams"
        (hwChange)="conceptSelected($event.id)"
        [(ngModel)]="concept"
        style="width: 100%"></hw-snomed-input-search>
      <a class="button" type="button" nz-button nzType="link" (click)="openSearch()">{{ 'Open search' }}</a>
    </div>

    <hw-snomed-description *ngIf="concept" [descriptions]="descriptions"></hw-snomed-description>

    <hw-snomed-translation
      *ngIf="concept"
      [descriptions]="translations"
      [conceptId]="concept.conceptId"></hw-snomed-translation>

    <hw-snomed-relationship *ngIf="concept" [relationships]="relationships"></hw-snomed-relationship>

    <nz-card class="card-simple" nzTitle="Form" *ngIf="concept">
      <hw-snomed-form
        [parsedConcept]="{ conceptId: concept?.conceptId }"
        #snomedForm
        (hwConceptChange)="updateExpression($event)"></hw-snomed-form>
      <label>{{ expression }}</label>
    </nz-card>

    <hw-snomed-refset *ngIf="concept" [refsets]="refsets"></hw-snomed-refset>

    <hw-snomed-reference *ngIf="concept" [conceptId]="concept.conceptId"></hw-snomed-reference>
  </div>
</nz-content>
